import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
export function IconListEntry(props) {
    const { icon, primaryText, secondaryText, onClick, button, dense } = props;
    const renderedContents = (_jsxs(_Fragment, { children: [_jsx(ListItemIcon, { children: icon }), _jsx(ListItemText, { primary: primaryText, secondary: secondaryText })] }));
    const useButton = button !== false;
    return useButton ? (_jsx(ListItemButton, { onClick: onClick, dense: dense, children: renderedContents })) : (_jsx(ListItem, { onClick: onClick, dense: dense, children: renderedContents }));
}
//# sourceMappingURL=IconListEntry.js.map